import React from 'react';
import './card.scss';

interface Props {
	prescription: { [key: string]: any }
}

const PrescriptionCard = ({ prescription }: Props) => {
  return (
    <div className="component_prescriptioncard">
      <div className='mb-3 fw-bolder'>{prescription.title}</div>
      <div className='d-flex justify-content-between mb-3'>
        <div>Quantity: {prescription.quantity}</div>
        <div>Supply (Days): {prescription.days_supply}</div>
      </div>
      <div>Directions:</div>
      <div>{prescription.directions}</div>
    </div>
  );
};

export default PrescriptionCard;